module.exports = __webpack_public_path__ + "media/images/icons/flags/KG-bb31a6c7ad74e1c6ad68fb862ab51363.svg";